import { Route, Routes } from "react-router";
import AIVideoHomepage from "./homepage/AIVideoHomepage";
import AIVideoSettings from "./video-settings/AIVideoSettings";
import AIVideoCreate from "./create-video/AIVideoCreate";
import AIVideoDetails from "./video-details";
import AIVideoList from "./video-list";

function AIVideoRoutes() {
  return (
    <Routes>
      <Route path="" element={<AIVideoHomepage />} />
      <Route path="settings" element={<AIVideoSettings />} />
      <Route path="new" element={<AIVideoCreate />} />
      <Route path="list" element={<AIVideoList />} />
      <Route path=":id" element={<AIVideoDetails />} />
    </Routes>
  );
}

export default AIVideoRoutes;
